import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/service/api.service';
import { ConfigService } from 'src/app/core/service/config.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultiAuctionService {
  constructor(private apiService: ApiService, private _config: ConfigService) { }

  getListing(roomId: string) {
    return this.apiService
      .get(`${environment.apiUrl}auction/list-auctions-by-multi-room/${roomId}`)
      .pipe(catchError(this.handleError));
  }
  getListingForAdmin(modal: any) {
    return this.apiService
      .get(`${environment.apiUrl}admin/auction/auctions`, modal)
      .pipe(catchError(this.handleError));
  }

  joinAuction(id: string) {
    return this.apiService
      .post(`${environment.apiUrl}auction/join/rooms/${id}`)
      .pipe(catchError(this.handleError));
  }
  withdrawAuction(id: string) {
    return this.apiService
      .post(`${environment.apiUrl}auction/leave/rooms/${id}`)
      .pipe(catchError(this.handleError));
  }
  ImortItemToNormalAuction(modal: any){
    return this.apiService
    .post(`${environment.apiUrl}admin/auction/auctions/change-room`,modal)
    .pipe(catchError(this.handleError));
  }

  SortItems(modal: any) {
    return this.apiService
    .post(`${environment.apiUrl}admin/auction/auctions/sort`,modal)
    .pipe(catchError(this.handleError));
  }
  handleError(error: any) {
    return throwError(error);
  }
}
